<template>
  <splash v-show="isLoading" title="코어독해 준비중..." />
  <splash v-show="isProc" title="잠시만 기다려 주세요." />
  <q-header reveal elevated class="bg-white text-black">
    <q-toolbar>
      <q-icon name="img:/assets/images/icon/ico_home.svg" :onclick="onClickHome" style="width: 2.4vw; height: 2.4vw; cursor: pointer" />
      <div style="display: flex; margin-left: 20px;">
        <q-btn flat icon="arrow_back_ios_new" :onClick="() => { nextExam(true); }" />
        <q-select filled v-model="model" use-input hide-selected fill-input input-debounce="0" :options="options"
          @filter="filterFn" style="width: 250px; ">
          <template v-slot:no-option>
            <q-item>
              <q-item-section class="text-grey">
                No results
              </q-item-section>
            </q-item>
          </template>
        </q-select>
        <q-btn flat icon="arrow_forward_ios" :onClick="() => { nextExam(); }" style="cursor: pointer" />
      </div>
    </q-toolbar>
  </q-header>
  <q-page-container>
    <q-page v-if="!videoStudy && !isKreadVisible" class="q-pa-md" style="height: calc(100vh - 150px)">
      <div class="row">
        <div class="col" style="height: calc(100vh - 82px)">
          <qbankHeaderVue :questionHeader="questionHeader" :inputIdx="inputIdx" @setInputAnswer="setInputAnswer"
            :bookNm="bookNm" />
        </div>
        <div v-if="(problemOrder > 0)" class="col" style="height: calc(100vh - 82px)">
          <!-- <qbankProblem :p-content="problem" v-if="tab === item.index" @setCheckedAnswer="setCheckedAnswer"
            @onChangeProblems="onChangeProblems" @setProblemResult="setProblemResult" /> -->
          <div>
            <qbankProblem :p-content="problem" v-if="problem" @onChangeProblems="onChangeProblems"
              @setInputAnswer="setInputAnswer" :answer="answer" />
          </div>
          <div>
            <qbankAnswer :p-content="problem" />
            <!-- <q-btn :onClick="getHtml" label="html 가져오기" /> -->
          </div>
          <!-- <cqBtn @onClickFn="test" :options="{ sound: 'next' }" label="test"></cqBtn> -->
        </div>
      </div>
      <!-- <div style="width: 100%; text-align: right;">
        <q-btn rounded label="읽기 완료" color="primary" size="lg" style="width: 300px" :onclick="stopTimer" />
      </div> -->
    </q-page>
    <div v-if="isKreadVisible" style="height: calc(100vh - 70px); padding-top: 40px;">
      <!-- <q-badge rounded color="#abacad" :label="data.etcInfo.etcCd02Nm + ' - 지문' + studyStore.process.exam?.passage"
              style="background-color: #abacad;padding: 5px 20px;" /> -->
      <div v-if="data?.kread"
        style="color:#1976D2; width:100%;display: inline-flex;justify-content: center;font-size: 30px;">
        <!-- <div>Kread </div> -->
        <img src="/assets/images/icon/icon_kread.svg" />
        <div style="background-color: #1976D2;color: white; border-radius: 50%;margin-left: 10px; padding:0 20px ;">
          {{ data?.kread }}</div>
      </div>
      <div style="color:black; width:100%;justify-content: center;font-size: 30px;">
        <div style="text-align: center;">{{ data?.title }}</div>
        <div style="font-size: 16px;text-align: center;">
          이번 지문을 읽기 위해 권장되는 시간은 <span style="color:#1976D2">{{ data?.standardReadingTime }}</span>입니다.</div>
      </div>
      <div style="width: 100%; height: calc(100vh - 340px);; display: flex; justify-content: center;">
        <div style="width: 70%; height: 100%;">
          <wordCahrt :chartText="(data.content?.replaceAll('br', ''))" />
        </div>
      </div>
      <div style="width: 100%;  display: flex; justify-content: center; margin-bottom: 20px;">
        <div class="word-chart_item" v-if="data.item?.headerBookDesc">
          글자수
          <div>{{ data.item?.headerBookDesc }}</div>
        </div>
        <q-separator vertical inset v-if="data.item?.headerKeyword" />
        <div class="word-chart_item" v-if="data.item?.headerKeyword">
          문단수
          <div>{{ data.item?.headerKeyword }}</div>
        </div>
        <q-separator vertical inset v-if="data.item?.headerEtcTxt05" />

        <div class="word-chart_item" v-if="data.item?.headerEtcTxt05">
          문장수
          <div>{{ data.item?.headerEtcTxt05 }}</div>
        </div>

        <q-separator vertical inset v-if="data.item?.headerEtcTxt07" />
        <div class="word-chart_item" v-if="data.item?.headerEtcTxt07">
          복문 수
          <div>{{ data.item?.headerEtcTxt07 }}</div>
        </div>
      </div>
      <div style="width: 100%;  display: flex; justify-content: center;">
        <q-btn rounded label="읽기 시작" color="primary" size="lg" style="width: 300px" :onclick="startTimer" />
      </div>
    </div>
    <div v-if="videoStudy" style="height: calc(100vh - 50px)">
      <div class="modal-model">
        모델답안 비교
      </div>
      <VideoTest
        videoSrc="https://media5jvqbd.fmkorea.com/files/attach/new2/20210301/2063168106/62449231/3424305738/b1b4e7075cece7bf3b0174253e99b524.mp4#t=1, 10" />
    </div>
  </q-page-container>
  <modalLayer v-if="store.visibleModal" :width="isKreadVisible ? '90%' : '400px'">
    <!-- <VideoTest /> -->
    <div v-if="isKreadVisible" style="height: calc(100vh - 70px);">
      <!-- <q-badge rounded color="#abacad" :label="data.etcInfo.etcCd02Nm + ' - 지문' + studyStore.process.exam?.passage"
        style="background-color: #abacad;padding: 5px 20px;" /> -->
      <div v-if="data?.kread"
        style="color:#1976D2; width:100%;display: inline-flex;justify-content: center;font-size: 30px;">
        <!-- <div>Kread </div> -->
        <img src="/assets/images/icon/icon_kread.svg" />
        <div style="background-color: #1976D2;color: white; border-radius: 50%;margin-left: 10px; padding:0 20px ;">
          {{ data?.kread }}</div>
      </div>
      <div style="color:black; width:100%;justify-content: center;font-size: 30px;">
        <div style="text-align: center;">{{ data?.title }}</div>
        <div style="font-size: 16px;text-align: center;">
          이번 지문을 읽기 위해 권장되는 시간은 <span style="color:#1976D2">{{ data?.standardReadingTime }}</span>입니다.</div>
      </div>
      <div style="width: 100%; height: calc(100vh - 340px);; display: flex; justify-content: center;">
        <div style="width: 70%; height: 100%;">
          <wordCahrt :chartText="(data.content?.replaceAll('br', ''))" />
        </div>
      </div>
      <div style="width: 100%;  display: flex; justify-content: center; margin-bottom: 20px;">
        <div class="word-chart_item" v-if="data.item?.headerBookDesc">
          글자수
          <div>{{ data.item?.headerBookDesc }}</div>
        </div>
        <q-separator vertical inset v-if="data.item?.headerKeyword" />
        <div class="word-chart_item" v-if="data.item?.headerKeyword">
          문단수
          <div>{{ data.item?.headerKeyword }}</div>
        </div>
        <q-separator vertical inset v-if="data.item?.headerEtcTxt05" />

        <div class="word-chart_item" v-if="data.item?.headerEtcTxt05">
          문장수
          <div>{{ data.item?.headerEtcTxt05 }}</div>
        </div>

        <q-separator vertical inset v-if="data.item?.headerEtcTxt07" />
        <div class="word-chart_item" v-if="data.item?.headerEtcTxt07">
          복문 수
          <div>{{ data.item?.headerEtcTxt07 }}</div>
        </div>
      </div>
      <div style="width: 100%;  display: flex; justify-content: center;">
        <q-btn rounded label="읽기 시작" color="primary" size="lg" style="width: 300px" :onclick="startTimer" />
      </div>
    </div>
    <div v-if="!isKreadVisible">
      <div style="width: 100%;  display: flex; justify-content: center;">
        <div class="text-h5">{{ time }}</div><br />
      </div>
      <div style="width: 100%;  display: flex; justify-content: center;">
        <div>표준 읽기 시간 <span style="color:#7ab4e7">{{ data?.standardReadingTime }}</span> </div>
      </div>
      <div style="width: 100%;  display: flex; justify-content: center;">
        <q-icon name="img:/assets/images/symbols/graph.svg" size="20px" :onclick="onClickHome"
          style="cursor: pointer" />
      </div>
      <div style="width: 100%;  display: flex; justify-content: center;">
        <!-- 표준 읽기 시간보다 {{ diffTime > 0 ? diffTime + '초 빨리' : (diffTime * -1) + '초 늦게' }} 읽었네요!<br /> -->
        표준 읽기 시간보다 {{ setSolveTimeMessage() }} 읽었네요!<br />
        지문을 분석하며 문제를 풀어보아요.
      </div>
      <br />
      <div v-if="!(Number(data.solveTime) > 60 && (Number(data.solveTime) - diffTime) < 30)"
        style="width: 100%;  display: flex; justify-content: center;">
        <q-btn rounded label="지문 분석 시작" color="primary" size="lg" style="width: 200px" :onclick="nextStep" />
      </div>
      <div v-if="(Number(data.solveTime) > 60 && (Number(data.solveTime) - diffTime) < 30)" style="text-align: center;">
        <q-btn rounded label="더 읽어 볼게요" color="grey-4" size="md" style="width: 150px; margin: 0px 5px;"
          :onclick="reStartTimer" />
        <q-btn rounded label="지문 분석 시작" color="primary" size="md" style="width: 150px; margin: 0px 5px;"
          :onclick="nextStep" />
      </div>
    </div>
  </modalLayer>
  <FloatingBtn :visible="problemOrder > 0" @on-click="() => { nextStep(); }" />
  <FloatingBtn :visible="problemOrder > 1" position="left" @on-click="() => { nextStep(false); }" />
</template>

<script setup>
import { historyBack } from "@/helpers/utils"
import splash from "@/components/template/splash.vue"
import { ref, onMounted, onUnmounted, watch, toRaw } from "vue";
import { DialogStore } from "@/store/modules/dialog";
import modalLayer from '@/components/layouts/layer/modalLayer.vue';
import qbankHeaderVue from "@/components/qbank/header.vue";
import qbankProblem from "@/components/qbank/problem.vue";
import qbankAnswer from "@/components/qbank/qbankAnswer.vue";
import studyHeader from "@/components/layouts/header/studyHeader.vue";
import wordCahrt from '@/components/chart/wordCahrt.vue';
import { getKrtExam, getKrtHeaders, getKrtProblem } from "@/api/modules/qbank";
import dataToParse from "@/helpers/qbankParser/dataParse";
import { getHeaderTitle, getKreadScore, getHeaderText, getEtcInfo, getHeader } from "@/helpers/qbankParser/qbankDataParse";
import { useQuasar } from 'quasar'
import moment from "moment";
import { soundEffect, soundTic } from "@/helpers/soundEffect";
import { StudyStore } from "@/store/modules/study";
import { useRouter } from "vue-router"
import cqBtn from "@/components/quasar/cqBtn.vue"
import { postAnswerCore, postCornerStart } from "@/api/modules/study";
import { examsData } from "@/views/testPage/examsData";
import VideoTest from "@/components/qbank/VideoTest.vue";
import _ from "lodash"
import FloatingBtn from "@/components/quasar/floatingBtn.vue";

// 학습준비화면 시간
const $q = useQuasar();
const router = useRouter();
const loadingTime = 1000;
const store = DialogStore();
const studyStore = StudyStore();
const isLoading = ref(null);
const isProc = ref(null);
const isKreadVisible = ref(null);
const data = ref(null);
const diffTime = ref(0);
let startTime;
let baseTime;
const time = ref(null);
const questionHeader = ref(null);
const bookNm = ref(null);
const videoStudy = ref(false);
let notif = null;
let problemMaps = [];
let problems = {};
let inputIdx = ref(0);
let answer = ref({});
let tmpAnswer = ref({});
let visibleScoring = false;  // 채점 표시

//TODO: 차후 스토어로 변경 필요
let problemOrder = ref(0);
let problem = ref(null);
let notiAnswer = null;
let notiInfo = null;
let notiNav = null;
let notiNavBack = null;
let notiType = 'first';

let cornerTime = {
  textReadStartDtm: null,
  textReadEndDtm: null,
  textReadTime: null,
  videoViewStartDtm: null,
  videoViewEndDtm: null,
  videoViewTime: null,
  cornerLearningStartDtm: null,
  cornerLearningEndDtm: null,
  cornerLearningTime: null,
}

const initCoreReading = (rs, v) => {
  getKrtHeaders({
    // version: '1.00.01', examNm: 'KRT_02_17_N_02_C'
    version: studyStore.exprVersion, examNm: model.value + '_C'
  }, (r) => {
    // console.log('!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!');
    // console.log(r.examIds[0]);
    // const tmpHeaderData = (r.header).filter(i => { return i.headerId === rs.content.headerId }).pop();
    const tmpHeaderData = (r.examMaps[r.examIds[0]]).filter(i => { return i.problemId === rs.content.problemId }).pop();

    // console.log('!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!');
    // console.log(tmpHeaderData);
    // console.log(rs);
    isLoading.value = false;
    isKreadVisible.value = true;

    // store.openModal(true);
    const tmpEtcInfo = getEtcInfo(rs);
    data.value = {
      content: getHeaderText(rs),
      kread: tmpEtcInfo.kread,
      title: tmpEtcInfo.title,
      etcInfo: tmpEtcInfo,
      standardReadingTime: moment('2022-10-01 00:00:00').add(tmpEtcInfo.solveTime, 's').format('m분ss초'),
      solveTime: tmpEtcInfo.solveTime,
      item: tmpHeaderData ? tmpHeaderData.property : null
    };
    questionHeader.value = getHeader(rs);
    bookNm.value = tmpEtcInfo.bookNm;

  });
}

const setProblem = (rs) => {
  problem.value = {
    problemId: rs.content.problemId,
    data: rs,
    studyTime: 0,
    answer: {},
    reAnswer: null,
    result: null,
    startDtm: moment().format('YYYY-MM-DD HH:mm:ss'),
    endDtm: null,
    problemClassCode: '1'
  }
}

const nextStep = (v = true) => {
  isProc.value = true;
  soundEffect('next');
  if (!problems[problemOrder.value]['startDtm']) {
    problems[problemOrder.value]['startDtm'] = moment().format('YYYY-MM-DD HH:mm:ss');
  }
  problems[(problemOrder.value)]['studyTime'] = problems[(problemOrder.value)]['studyTime'] + moment.duration(moment().diff(startTime)).asSeconds();
  startTime = moment();
  if (notiType === 'last' && v) {
    // 학습 완료
    // 학습 데이터 저장
    return saveResult();
    // return router.push('/authenticreading');
  }
  if (!v) {
    problemOrder.value = problemOrder.value - 1;
  } else {
    problemOrder.value = problemOrder.value + 1;
  }
  if (problemOrder.value === 1) {
    notiType = 'first'
    store.openModal(false);
    // console.log(problems);
    questionHeader.value = getHeader(problems[(problemOrder.value)].data);
  } else if (problemOrder.value === Object.keys(problems).length - 1) {
    notiType = 'last'
  } else {
    notiType = 'middle'
  }
  // problemOrder.value = problemOrder.value = 2;
  // getKrtProblem({
  //   version: '1.00.01', problemId: problemMaps[problemOrder.value].problemId
  // }, setProblem)
  problem.value = {
    ...problems[problemOrder.value]
  };
  const inputTypes = ['60', '61', '70'];
  if (inputTypes.includes(problems[problemOrder.value].data.content.property.problem.typeCd)) {
    inputIdx.value = problems[problemOrder.value].data.content.solution.answer.texts.length;
  }
  notiNav !== null && notiNav();
  notiNavBack !== null && notiNavBack();
  notiNav = null;
  notiNavBack = null;
  // setNotiNav();
  // startTime = moment();
  console.log('************************************************************');
  console.log(problems);
  console.log('************************************************************');
  isProc.value = false;
}

const initExams = (v = null) => {
  if (!v) {
    return false;
  }
  getKrtExam({
    // version: '1.00.01', examNm: 'KRT_02_17_N_02_C'
    version: studyStore.exprVersion, examNm: v + '_C'
  }, (rs) => {
    // TODO: store 에 코어리딩 문제 저장
    // rs.examMaps 
    if (rs.examMaps) {
      const exId = rs.examIds[0];
      const problemArr = rs.examMaps[exId];
      // getKrtProblem({
      //   version: '1.00.01', problemId: rs.examMaps[exId][0].problemId
      //   // version: '1.00.01', problemId: 382222
      // }, initCoreReading);
      problemArr.forEach((item, index) => {
        getKrtProblem({
          version: studyStore.exprVersion, problemId: item.problemId
          // version: '1.00.01', problemId: 382222
        }, (r) => {
          problems = {
            ...problems, [index]: {
              problemId: r.content.problemId,
              done: false,
              data: r,
              studyTime: 0,
              answer: {},
              isRight: null,
              reAnswer: null,
              reAnswerIsRight: null,
              result: null,  //'right': 정답, 'halfWrong':1차오답 , 'halfRight':2차정답 , 'wrong':2차오답
              startDtm: null,
              endDtm: null,
              problemClassCode: '1',
              rightAnswer: r.content.solution.answer.detail,
            }
          }
          if (index === 0) {
            initCoreReading(r, v);
            setProblem(r);
          }
        });
      });
    }
  });
}

watch(() => studyStore.process, (newValue) => {
  isLoading.value = true;
  isKreadVisible.value = false;
  initExams()
});

const model = ref(null);

watch(() => model.value, (newValue) => {
  isLoading.value = true;
  isKreadVisible.value = false;
  problemOrder.value = 0;
  notiType = 'first';
  initExams(newValue);
});

onMounted(() => {
  isLoading.value = true;
  isKreadVisible.value = false;
  // setTimeout(() => {
  //   getCoreReacdingApi({}, (rs) => {
  //     isLoading.value = false;
  //     isKreadVisible.value = true;
  //     store.openModal(true);
  //     data.value = { ...rs, baseTime: moment('2022-10-01 00:00:00').add(rs.time, 's').format('m분ss초') };
  //   })
  // }, loadingTime);
  setTimeout(() => { initExams(); }, 1000)
  // getKrtExam({
  //   // version: '1.00.01', examNm: 'KRT_02_17_N_02_C'
  //   version: studyStore.exprVersion, examNm: studyStore.process.exam.examCode + '_C'
  // }, (rs) => {
  //   // TODO: store 에 코어리딩 문제 저장
  //   // rs.examMaps 
  //   if (rs.examMaps) {
  //     const exId = rs.examIds[0];
  //     const problemArr = rs.examMaps[exId];
  //     // getKrtProblem({
  //     //   version: '1.00.01', problemId: rs.examMaps[exId][0].problemId
  //     //   // version: '1.00.01', problemId: 382222
  //     // }, initCoreReading);
  //     problemArr.forEach((item, index) => {
  //       getKrtProblem({
  //         version: '1.00.01', problemId: item.problemId
  //         // version: '1.00.01', problemId: 382222
  //       }, (r) => {
  //         problems = {
  //           ...problems, [index]: {
  //             problemId: r.content.problemId,
  //             done: false,
  //             data: r,
  //             studyTime: 0,
  //             answer: {},
  //             reAnswer: null,
  //             correctiveStatus: false,
  //             result: null,
  //             totalCnt: 0,
  //             process: 1,
  //           }
  //         }
  //         if (index === 0) {
  //           initCoreReading(r);
  //           setProblem(r);
  //         }
  //       });
  //     });
  //   }
  // });
})

const startTimer = () => {
  isKreadVisible.value = false;
  startTime = moment();
  baseTime = moment().add(data.value.time, "s")
  store.openModal(false);
  cornerTime.textReadStartDtm = moment().format('YYYY-MM-DD HH:mm:ss');
  cornerTime.cornerLearningStartDtm = moment().format('YYYY-MM-DD HH:mm:ss');
  nextStep();
  // 지문학습 시작
  // postLessonStart({ testPaperName: studyStore.process.exam.examCode, type: '01' }, () => { })
}
const reStartTimer = () => {
  startTime = moment();
  store.openModal(false);
  diffTime.value = diffTime.value - data.value.solveTime;
  stopNoti();
}

const stopTimer = () => {
  store.openModal(true);
  time.value = moment(moment() - startTime).format('mm분 ss초');
  // diffTime.value = Math.round(moment.duration(baseTime.diff(moment())).asSeconds());
  diffTime.value = diffTime.value + (data.value.solveTime - moment.duration(moment().diff(startTime)).asSeconds());
  problems[problemOrder.value]['studyTime'] = diffTime.value;
  problems[problemOrder.value]['endDtm'] = moment().format('YYYY-MM-DD HH:mm:ss');
  notif = null
  cornerTime.textReadEndDtm = moment().format('YYYY-MM-DD HH:mm:ss');
  cornerTime.textReadTime = diffTime.value;
}

const setSolveTimeMessage = () => {
  let rsMsg = '';
  const tmpTime = Math.round(diffTime.value);
  if (data.value.solveTime < 60) {
    if (tmpTime > 0) {
      rsMsg = (tmpTime + '초 빨리');
    } else {
      rsMsg = ((tmpTime * -1) + '초 늦게');
    }
  } else {
    if (tmpTime > 30) {
      rsMsg = (tmpTime + '초 빨리');
    } else if (tmpTime > 0) {
      rsMsg = (tmpTime + '초 빨리');
    } else {
      rsMsg = ((tmpTime * -1) + '초 늦게');
    }
  }
  return rsMsg;
};

const stopNoti = () => {
  if (notif === null) {
    notif = $q.notify({
      group: false,
      timeout: 0,
      message: '',
      multiLine: true,
      // color: 'secondary',
      classes: 'force-inlinie',
      position: 'bottom-right',
      color: 'primary',
      actions: [{ label: '읽기완료', color: 'white', handler: () => { stopTimer(); } }]
    })
  }
}

const answerNoti = () => {
  if (notiAnswer === null) {
    notiAnswer = $q.notify({
      group: false,
      timeout: 0,
      message: '',
      multiLine: true,
      color: 'red-12',
      classes: 'force-inlinie',
      position: 'bottom-right',
      actions:
        [{ label: '정답 확인', color: 'white', handler: () => { setEsasyQuestionsResult(); } }]
    });
  } else {

  }
}

onUnmounted(() => {
  notif !== null && notif();
  notiAnswer !== null && notiAnswer();
  notiNav !== null && notiNav();
  notiNavBack !== null && notiNavBack();
  isLoading.value = true;
  isKreadVisible.value = true;
  store.openModal(false);
})

// watch(() => problem.value, (newValue) => {
//   // const questionHeader = JSON.parse(JSON.stringify(newValue));
//   console.log('!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!' + newValue);
//   const vContent = toRaw(newValue);
//   console.log(vContent);
// });
// watch(() => problem.visibleScoring, (newValue) => {
//   // const questionHeader = JSON.parse(JSON.stringify(newValue));

// });

const onChangeProblems = (val) => {
  if (val === 'next') {
    problemOrder.value = (Number(problemOrder.value) + 1);
  } else if (val === 'prev') {
    problemOrder.value = (Number(problemOrder.value) - 1);
  }
}

const setInputAnswer = (id, val, typ = true) => {
  // soundEffect('tic');
  tmpAnswer.value = { ...tmpAnswer.value, [id]: val };
  if (problems[problemOrder.value]['result'] != null) {
    problems[problemOrder.value]['reAnswer'] = tmpAnswer.value;
  } else {
    problems[problemOrder.value]['answer'] = tmpAnswer.value;
  }
  let tmpCheck = 0;
  Object.values(tmpAnswer.value).forEach(item => {
    // console.log(item);
    if (item !== '') { tmpCheck += 1; }
  });
  if (tmpCheck >= inputIdx.value) {
    answerNoti();
  } else {
    notiAnswer !== null && notiAnswer();
    notiAnswer = null;
  }
  if (typ) {
    // console.log(problems[problemOrder.value]);
    problem.value = {
      ...problem.value, answer: { ...tmpAnswer.value }
    }
  }
}

const setNotiNav = () => {
  if (notiNav === null) {
    notiNav = $q.notify({
      group: false,
      timeout: 0,
      message: '',
      color: 'blue-6',
      classes: 'force-inline',
      position: 'bottom-right',
      multiLine: true,
      actions:
        notiType === 'last' ? [
          { label: '개념학습', iconRight: 'arrow_forward_ios', color: 'white', handler: () => { nextStep(); } }] : [{ label: '다음문제', iconRight: 'arrow_forward_ios', color: 'white', handler: () => { nextStep(); } }]
    })
  }
  if (notiType !== 'first') {
    if (notiNavBack === null) {
      notiNavBack = $q.notify({
        group: false,
        timeout: 0,
        message: '',
        color: 'grey-12',
        classes: 'force-inline',
        position: 'bottom-left',
        multiLine: true,
        actions: [{ label: '', icon: 'arrow_back_ios_new', color: 'grey-6', handler: () => { nextStep(false); } }],
      })
    };
  }
}
const setEsasyQuestionsResult = () => {
  // soundEffect('result');
  if (!problems[problemOrder.value]['endDtm']) {
    problems[problemOrder.value]['endDtm'] = moment().format('YYYY-MM-DD HH:mm:ss');
  }
  if (problems[problemOrder.value]['result'] != null) {
    problems[(problemOrder.value)]['studyTime'] = problems[(problemOrder.value)]['studyTime'] + moment.duration(moment().diff(startTime)).asSeconds();
  }
  // problems.value[problemOrder.value]
  const tmpProblem = problems[problemOrder.value];
  let isCorrectAll = true;
  const answerIdx = problems[problemOrder.value]['result'] != null ? 2 : 1;
  const tmpAnswerArr = problems[problemOrder.value][answerIdx === 2 ? 'reAnswer' : 'answer'];
  const correctArr = [];
  // console.log(tmpAnswerArr);
  Object.keys(tmpAnswerArr).forEach((key) => {
    // console.log('!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!');
    // console.log(key);
    let finalResult = false;
    const answerDetails = [...tmpProblem.data.content.solution.answer.detail].filter((i) => {
      return i.ord === Number(key)
    });
    // console.log(tmpProblem.data.content.solution.answer.detail);
    // console.log(answerDetails);

    answerDetails.map((item) => {
      let tmpUserAnswer = tmpAnswerArr[key];
      let tmpanswer = item['answer'];
      // 공백제거후 비교
      if (item.ignorespace === 'Y') {
        tmpUserAnswer = tmpUserAnswer.replaceAll(' ', '');
        tmpanswer = tmpanswer.replaceAll(' ', '');
      }
      // 대소문자 구분후 비교
      if (item.chkcase === 'N') {
        tmpUserAnswer = tmpUserAnswer.toLowerCase();
        tmpanswer = tmpanswer.toLowerCase();
        // console.log(tmpUserAnswer.toLowerCase())
        // console.log(tmpanswer.toLowerCase())
        // console.log(tmpUserAnswer === tmpanswer)
      }
      // console.log(tmpUserAnswer.toLowerCase())
      // console.log(tmpanswer.toLowerCase())
      // console.log(tmpUserAnswer === tmpanswer)
      if (!finalResult && tmpUserAnswer === tmpanswer) {
        finalResult = true;
      }
    });
    // console.log('########################## 11');
    if (finalResult) {
      // console.log('########################## 11 -1');
      correctArr.push({ isCorrect: true, answer: problems[problemOrder.value][answerIdx === 2 ? 'reAnswer' : 'answer'][key] })
    } else {
      // console.log('########################## 11 -2');
      isCorrectAll && (isCorrectAll = false);
      correctArr.push({ isCorrect: false, answer: problems[problemOrder.value][answerIdx === 2 ? 'reAnswer' : 'answer'][key] })
    }
    // console.log('########################## 11 end');
  });
  // console.log('########################## 22');
  if (answerIdx === 1 && isCorrectAll) {
    // console.log('########################## 221');
    problems[problemOrder.value]['isRight'] = true;
    problems[problemOrder.value]['result'] = { marking: 'right', answer: correctArr };
    setNotiNav();
  } else if (answerIdx === 1 && !isCorrectAll) {
    // console.log('########################## 222');
    problems[problemOrder.value]['isRight'] = false;
    problems[problemOrder.value]['result'] = { marking: 'halfWrong', answer: correctArr }
    $q.notify({
      // message: '오답은 한번 다시 풀 수 있어요.',
      message: '다시 한 번 풀어 보세요.',
      timeout: 1000,
      // color: 'secondary',
      position: 'right'
    })
  } else if (answerIdx === 2 && isCorrectAll) {
    // console.log('########################## 223');
    problems[problemOrder.value]['reAnswerIsRight'] = true;
    problems[problemOrder.value]['result'] = { marking: 'halfRight', answer: correctArr };
    setNotiNav();
  } else if (answerIdx === 2 && !isCorrectAll) {
    // console.log('########################## 224');
    problems[problemOrder.value]['reAnswerIsRight'] = false;
    problems[problemOrder.value]['result'] = { marking: 'wrong', answer: correctArr };
    setNotiNav();
  }
  // console.log('*********************************************************************************');
  // console.log(problems[problemOrder.value]['result']);
  // console.log('*********************************************************************************');
  notiAnswer = null;
  // problem.value = problems[problemOrder.value];
  problem.value = { ...problems[problemOrder.value] };
  // console.log(problem);


  // if (tmpProblem.data.content.solution.answer.detail) {
  //   const correctArr = [];
  //   tmpProblem.data.content.solution.answer.detail.map(item => {
  //     // Object.entries(problems[problemOrder.value]['answer']).forEach(([key, value]) => {
  //     // let tmpUserAnswer = value;
  //     let tmpUserAnswer = problems[problemOrder.value][answerIdx === 2 ? 'reAnswer' : 'answer'][item.ord];
  //     let tmpanswer = item['answer'];
  //     // 공백제거후 비교
  //     if (item.ignorespace === 'Y') {
  //       tmpUserAnswer = tmpUserAnswer.replaceAll(' ', '');
  //       tmpanswer = tmpanswer.replaceAll(' ', '');
  //     }
  //     // 대소문자 구분후 비교
  //     if (item.chkcase === 'N') {
  //       tmpUserAnswer = tmpUserAnswer.toLowerCase();
  //       tmpanswer = tmpanswer.toLowerCase();
  //       console.log(tmpUserAnswer.toLowerCase())
  //       console.log(tmpanswer.toLowerCase())
  //       console.log(tmpUserAnswer === tmpanswer)
  //     }
  //     if (tmpUserAnswer === tmpanswer) {
  //       correctArr.push({ isCorrect: true, answer: problems[problemOrder.value][answerIdx === 2 ? 'reAnswer' : 'answer'][item.ord] })
  //     } else {
  //       isCorrectAll && (isCorrectAll = false);
  //       correctArr.push({ isCorrect: false, answer: problems[problemOrder.value][answerIdx === 2 ? 'reAnswer' : 'answer'][item.ord] })
  //     }
  //     // });
  //   })
  //   if (answerIdx === 1 && isCorrectAll) {
  //     problems[problemOrder.value]['isRight'] = true;
  //     problems[problemOrder.value]['result'] = { marking: 'right', answer: correctArr };
  //     setNotiNav();
  //   } else if (answerIdx === 1 && !isCorrectAll) {
  //     problems[problemOrder.value]['isRight'] = false;
  //     problems[problemOrder.value]['result'] = { marking: 'halfWrong', answer: correctArr }
  //     $q.notify({
  //       // message: '오답은 한번 다시 풀 수 있어요.',
  //       message: '다시 한 번 풀어 보세요.',
  //       timeout: 1000,
  //       // color: 'secondary',
  //       position: 'right'
  //     })
  //   } else if (answerIdx === 2 && isCorrectAll) {
  //     problems[problemOrder.value]['reAnswerIsRight'] = true;
  //     problems[problemOrder.value]['result'] = { marking: 'halfRight', answer: correctArr };
  //     setNotiNav();
  //   } else if (answerIdx === 2 && !isCorrectAll) {
  //     problems[problemOrder.value]['reAnswerIsRight'] = false;
  //     problems[problemOrder.value]['result'] = { marking: 'wrong', answer: correctArr };
  //     setNotiNav();
  //   }
  //   console.log('*********************************************************************************');
  //   console.log(problems[problemOrder.value]['result']);
  //   console.log('*********************************************************************************');
  //   notiAnswer = null;
  //   // problem.value = problems[problemOrder.value];
  //   problem.value = { ...problems[problemOrder.value] };
  //   console.log(problem);
  // }
}

const saveResult = () => {
  // let tmpRs = [];
  // Object.entries(problems).forEach(([key, value]) => {
  //   if (key !== '0') {
  //     let tmpVal = { ...value };
  //     delete tmpVal.done;
  //     delete tmpVal.data;
  //     delete tmpVal.result;
  //     tmpVal.rightAnswer = JSON.stringify(tmpVal.rightAnswer);
  //     tmpVal.answer = JSON.stringify(tmpVal.answer);
  //     tmpVal.reAnswer = JSON.stringify(tmpVal.reAnswer);
  //     tmpRs.push(tmpVal);
  //   }
  // })
  // const saveData = {
  //   examNm: studyStore.process.exam.examCode,
  //   // examNm: 'KRT_01_02_L_01',
  //   exprVersion: studyStore.exprVersion,
  //   type: studyStore.process.exam.type,
  //   cornerTime,
  //   submission: tmpRs
  // }
  // console.log('saveData %%%%%%%%%%%%%%%%%%%%%%%%%');
  // console.log(saveData);
  // postAnswerCore(saveData, () => {
  //   // router.push('/authenticreading');
  // })
}



const options = ref(stringOptions);

const stringOptions = examsData;
model.value = stringOptions[0];

const filterFn = (val, update, abort) => {
  update(() => {
    const needle = val.toLowerCase()
    options.value = [...stringOptions].filter(v => v.toLowerCase().indexOf(needle) > -1)
  })
}

const nextExam = (back = false) => {
  console.log('@@@@@@@@@@@@@@@@@@@@@@@@@@@ ');
  console.log(stringOptions);
  console.log(model.value);
  // const fIndex = stringOptions.findIndex((e, i) => { e === model.value });
  const fIndex = _.findIndex(stringOptions, function (o) { return o === model.value; });
  console.log(fIndex);
  if (back) {
    if (fIndex !== 0)
      model.value = stringOptions[fIndex - 1]
  } else {
    if (fIndex !== stringOptions.length - 1)
      model.value = stringOptions[fIndex + 1]
  }
}

const onClickHome = () => {
  store.openConfirmDialog({
    message: '중단하고 홈으로 이동하시겠습니까?',
    cancel: '닫기',
    ok: '확인',
    callback: () => { router.push('/learninghome') },
  });
}
</script>

<style scoped lang="scss">
.word-chart_item {
  padding: 0px 20px;
  text-align: center;
}

.modal-model {
  position: absolute;
  bottom: 50px;
  /* left: 50%; */
  right: 20px;
  margin-left: -48px;
  margin-top: -48px;
  z-index: 100;
  width: 300px;
  height: calc(100% - 120px);
  background-color: white;
  border-radius: 20px;
  padding: 20px;
  opacity: 0.8;
}
</style>
